module.exports = "/_next/static/images/close-008a091a.png";